import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var SunIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12 19a1 1 0 01.993.883L13 20v3a1 1 0 01-1.993.117L11 23v-3a1 1 0 011-1zm6.613-1.79l.094.083 2 2a1 1 0 01-1.32 1.497l-.094-.083-2-2a1 1 0 011.32-1.497zm-13.32.083a1 1 0 111.414 1.414l-2 2a1 1 0 11-1.414-1.414zM12 6a6 6 0 110 12 6 6 0 010-12zm0 2a4 4 0 100 8 4 4 0 000-8zm-8 3a1 1 0 01.117 1.993L4 13H1a1 1 0 01-.117-1.993L1 11h3zm19 0a1 1 0 01.117 1.993L23 13h-3a1 1 0 01-.117-1.993L20 11h3zM4.613 3.21l.094.083 2 2a1 1 0 01-1.32 1.497l-.094-.083-2-2a1 1 0 011.32-1.497zm16.094.083a1 1 0 01.083 1.32l-.083.094-2 2a1 1 0 01-1.497-1.32l.083-.094 2-2a1 1 0 011.414 0zM12 .5a1 1 0 01.993.883L13 1.5V4a1 1 0 01-1.993.117L11 4V1.5a1 1 0 011-1z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
SunIcon.isCarinaIcon = true;
export default SunIcon;
